<h3 mat-dialog-title>Preisgruppe anlegen</h3>
<mat-dialog-content>
    <mat-form-field style="width: 100%">
        <input matInput type="text" placeholder="Bezeichnung" [(ngModel)]="preisgruppe.bezeichnung" />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="save()">Speichern</button>
</mat-dialog-actions>
